import { useEffect, useState } from '@wordpress/element';
import ErrorHandler from './utils/ErrorHandler';
import PhonePrefix from "./components/phone-prefix";


const settings = window.wc.wcSettings.getSetting("payshop_mbway_data", {});
const label = window.wp.htmlEntities.decodeEntities(settings.title);
const icon = settings.icon;

const Content = ( props ) => {
	const { eventRegistration, emitResponse } = props;
	const { onPaymentSetup, onCheckoutFail  } = eventRegistration;

    const [prefix, setPrefix] = useState('+351');
    const [phone, setPhone] = useState('');
    const prefixRef = React.useRef(prefix);
    const phoneRef = React.useRef(phone);

	function prefixChange(e) {
        prefixRef.current = e.target.value;
        setPrefix(e.target.value);
    }

    function phoneChange(e) {
        const value = e.target.value.replace(/\D/g, '').slice(0, 9);
        phoneRef.current = value;
        setPhone(value);
    }

	useEffect( () => {
		const unsubscribe = onPaymentSetup( async () => {
			const phone = phoneRef.current;
			const prefix = prefixRef.current;

			if ( phone !== '' && prefix !== '' ) {
				return {
					type: emitResponse.responseTypes.SUCCESS,
					meta: {
						paymentMethodData: {
							prefix,
							phone,
							payshop_mbway_nonce: settings.nonce
						},
					},
				};
			}

			return {
				type: emitResponse.responseTypes.ERROR,
				message: settings.error_message,
			};
		} );

		onCheckoutFail(async (paymentResponse) => {
			// Extract error message from paymentResponse object
			const errorMessage = paymentResponse.processingResponse.paymentDetails.errorMessage ?? '';
		  
			let errorHandler = new ErrorHandler(
                'Default message',
                document.querySelector('.woocommerce-notices-wrapper')
            );

            errorHandler.clear();
            errorHandler.message(errorMessage);
        });

		// Unsubscribes when this component is unmounted.
		return () => {
			unsubscribe();
		};
	}, [
		emitResponse.responseTypes.ERROR,
		emitResponse.responseTypes.SUCCESS,
		onPaymentSetup,
	] );

	return <fieldset id="wc-payshop_card-cc-form" className="wc-credit-card-form wc-payment-form">
                <p className="form-row form-row-wide woocommerce-validated" style={{display: "flex"}}>
					<PhonePrefix onChange={prefixChange} />
                    <input value={phone.replace(/(\d{3})(?=\d)/g, '$1 ')} onChange={phoneChange} id="id-phone-number" placeholder="Número Telemóvel" className="input-text wc-credit-card-form-card-number" inputmode="numeric" autocorrect="no" autocapitalize="no" spellcheck="no" type="text" data-checkout="wbwayNumber" name="phone" maxlength="11" required style={{flexGrow: "1"}} />
                </p>
            </fieldset>;
};

const Block_Gateway = {
    name: "payshop_mbway",
    label: <div style={{display: "flex", alignItems: "center"}}>
            <span>{label}</span>
            <img src={icon} style={{marginLeft: "10px"}} />
        </div>,
    content: <Content />,
    edit: <div>{label}</div>,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

window.wc.wcBlocksRegistry.registerPaymentMethod(Block_Gateway);